import {
  ContextualMenuPopper,
  ContextualMenuPopperMenuItem,
  ContextualMenuPopperProps,
  ContextualMenuPopperTrigger
} from '@archer-technologies/ui-components';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import * as React from 'react';

interface FilterPluginProps {
  menuItems: ContextualMenuPopperMenuItem[];
  translate: any;
}

const pluginDependencies = [{ name: 'Toolbar' }];

class ToolbarMore extends React.Component<FilterPluginProps> {
  public render() {
    const { menuItems, translate } = this.props;
    const trigger: ContextualMenuPopperTrigger = {
      text: translate('cmmn:selectFromList'),
      icon: 'MoreHoriz',
      popperPosition: 'bottom-end'
    };

    const contextualMenuProps: ContextualMenuPopperProps = {
      trigger,
      menuItems,
      translate
    };

    return (
      <Plugin name="toolbarMoreFilter" dependencies={pluginDependencies}>
        <Template name="toolbarContent">
          <TemplatePlaceholder />
          <div>
            <ContextualMenuPopper {...contextualMenuProps} />
          </div>
        </Template>
      </Plugin>
    );
  }
}

export { ToolbarMore };
